export default "__VITE_ASSET__f9e4f9ed__"